// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__uNtxt","message":"tooltip_message__sG2i5","rotate":"tooltip_rotate__xfAsY"};